export const state = {
  captchaImage: {
    imgsIo: '',
    ticket: ''
  },
  userInfo: {}
};
